module.exports = __webpack_public_path__ + "media/jackpot_winner_3.0a367d79.mp3";